
import ViewBase from '../../view-base.view';
import FileUploadComponent from '../../../components/file/file-upload.component';
import SelectUserComponent from "../../../components/user/select-user.component";
import announcementModel from '../../../models/communication/announcement.model';

export default function AnnouncementAddView() {
    ViewBase.call(this);

    let onAddClose = (e) => { };
    let onSaveComplete = (e) => { };

    let _uploadingFiles = [];

    let _selectedRecipients = [];
    let inputDataModel = { title: "", content: "" };
    
    let _getTitle = (e) => {
        inputDataModel.title = e.target.value;
    }

    let _getContent = (e) => {
        inputDataModel.content = e.target.value;
    }

    let _isAllInputsValid = () => {
        if (_selectedRecipients.length == 0) {

            this.showErrorMessage(this.getText("EM00000183", "Please select recipients"));

            return false;
        }

        if (inputDataModel.title.trim().length == 0) {

            this.showErrorMessage(this.getText("EM00000189", "Invalid Title"));
            
            return false;
        } 
        
        if (inputDataModel.content.trim().length == 0) {

            this.showErrorMessage(this.getText("EM00000190", "Invalid Content"));

            return false;
        }

        return true;
    }

    let _save = () => {
        if (_uploadingFiles.length > 0) {
            let _valid = _isAllInputsValid();
            if (_valid) {

                let filesFormData = new FormData();

                _uploadingFiles.forEach(function (v, i) {
                    filesFormData.append("file", v);
                });

                announcementModel.announcementUploadMultipleFiles(
                    (result) => {
                        _saveAnnouncement(result, true);
                    },
                    (error) => {
                        this.handleError(error);
                    },
                    filesFormData

                )
            }

        } else {
            let _valid = _isAllInputsValid();
            if (_valid) {
                _saveAnnouncement([], false);
            }
        }
    }

    let _saveAnnouncement = (fileResponses, isFilesIncluded) => {
        let _uplaodedFiles = [];
        let _userList = [];

        if (isFilesIncluded) {
            fileResponses.forEach(function (file) {
                _uplaodedFiles.push(file[0].id);
            });
        }

        _selectedRecipients.forEach(function (user) {
            _userList.push(user.userID);
        });

        announcementModel.announcementSave(
            (result) => {
                onSaveComplete(result);
            },
            (error) => {
                this.handleError(error);
            },
            _userList.join('^'),
            _uplaodedFiles.join('^'),
            inputDataModel.title,
            inputDataModel.content
        )

    }

    let _cancel = (e) => {
        onAddClose(e);
    }
    
    return {

        oninit: function (vnode) {


            if (vnode.attrs.onAddClose) {
                onAddClose = vnode.attrs.onAddClose;
            }
            if (vnode.attrs.onSaveComplete) {
                onSaveComplete = vnode.attrs.onSaveComplete;
            }

        },
        view: (vnode) => {
            return [
                m('.row',
                    m('col-md-12', 
                        m('.card',
                        m('.card-body',
                            m('.row',
                                m('.col-md-12.g-3', 
                                    m('label.form-label', this.getText("LT00000039", "Recipients")),
                                    m('span.redText', "*"),
                                    m(SelectUserComponent, {
                                        default: {
                                          userStatusCode: '0001'
                                        },
                                        required: true,
                                        hideMyTeam: true,
                                        onSelect: (s) => {
                                            _selectedRecipients = s;
                                        },
                                        selectedUserList: _selectedRecipients,
                                    })
                                ),
                                m('.col-md-12.g-3', 
                                    m('label.form-label', this.getText("LT00000037", "Title"), 
                                        m('span.redText', "*")
                                    ), 
                                    m('input[type=text][placeholder=' + this.getText("LT00000037", "Title") + '][value="' + inputDataModel.title + '"].form-control.form-control-bg', { onchange: _getTitle }
                                    )
                                ),
                                m('.col-md-12.g-3', 
                                    m('label.form-label', this.getText("LT00000056", "Content"), 
                                    m('span.redText', "*")), 
                                    m('textarea#txtContent.form-control.form-control-bg', 
                                        { 
                                            onchange: _getContent, 
                                            style: "height: 84px;", 
                                            placeholder: this.getText("LT00000056", "Content"),
                                            // maxlength: 255 
                                        },
                                        inputDataModel.content
                                    ),
                                ),
                                m('.col-md-12.g-3', 
                                    m('label.form-label', this.getText("LT00000047", "Attachments")),
                                    m(FileUploadComponent, {
                                        acceptableFileTypes: [ '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.jpg', '.jpeg', '.png' ],
                                        onGettingFiles: (e) => { 
                                            _uploadingFiles = e;
                                        }
                                    }) 
                                )
                            ),
                        ),
                        m('.card-footer',
                            m('.col-md-12.gap-2.d-flex.justify-content-end',
                                m(
                                    "button.btn.btn-primary[type='button']", { onclick: _save },
                                    this.getText("LT00000022", "Save")
                                ),
                                m(
                                    "button.btn.btn-white[type='button']", { onclick: _cancel },
                                    this.getText("LT00000021", "Close")
                                )
                            )
                        )
                        )
                    ),
                ),

                this.getBaseViews()];
        }
    }
}
